import React from 'react';
import './CookiePolicy.css'; // Importing CSS for styling

function CookiePolicy() {
  return (
    <div className="cookie-policy-container" style={{ position: "relative", zIndex: 1 , backgroundColor: "white"}}>
      <h1>Cookie Policy</h1>
      <p>Amalgam Inc ("we", "our", or "us") values your privacy and is committed to being transparent about the technologies we use. This Cookie Policy explains what cookies are, how we use them, and your choices regarding their use on our website.</p>

      <h2>1. What Are Cookies?</h2>
      <p>Cookies are small text files that are stored on your device (computer, smartphone, tablet) when you visit a website. They help the website recognize your device, store preferences, and enhance your browsing experience. Cookies can be either "session cookies" (which are deleted when you close your browser) or "persistent cookies" (which remain on your device until they expire or are deleted).</p>

      <h2>2. Types of Cookies We Use</h2>
      <p>We use the following types of cookies on our website:</p>
      <h3>a) Essential Cookies</h3>
      <p>These cookies are necessary for the website to function properly. Without these cookies, certain features of the website may not be available, and the site may not perform as intended.</p>
      <p>Examples:</p>
      <ul>
        <li>Remembering login sessions</li>
        <li>Maintaining security of the website</li>
      </ul>
      <h3>b) Performance/Analytics Cookies</h3>
      <p>These cookies collect information about how visitors interact with our website, such as which pages are visited most often and whether visitors encounter errors. This information helps us improve our website's functionality and performance.</p>
      <p>Examples:</p>
      <ul>
        <li>Google Analytics cookies</li>
        <li>Internal traffic monitoring tools</li>
      </ul>
      <h3>c) Functionality Cookies</h3>
      <p>These cookies allow the website to remember choices you make (such as your language preference) and provide enhanced, more personalized features.</p>
      <p>Examples:</p>
      <ul>
        <li>Remembering user preferences</li>
        <li>Customizing the user interface</li>
      </ul>
      <h3>d) Advertising/Targeting Cookies</h3>
      <p>We may use these cookies to deliver advertisements that are relevant to your interests. They may also limit the number of times you see an ad and help measure the effectiveness of advertising campaigns.</p>
      <p>Examples:</p>
      <ul>
        <li>Cookies set by advertising networks (e.g., Google Ads, Facebook Pixel)</li>
      </ul>

      <h2>3. Third-Party Cookies</h2>
      <p>We may allow third-party service providers to place cookies on your device to provide services such as analytics and targeted advertising. These third-party cookies are subject to their own privacy policies, and we encourage you to read those policies for further information.</p>

      <h2>4. How to Manage or Disable Cookies</h2>
      <p>You have the right to control the use of cookies on our website. You can manage your preferences or disable cookies entirely through the following methods:</p>
      <p>Cookie Settings on Our Website: You can click on the "Cookie Settings" link at the bottom of our website to manage your cookie preferences.</p>
      <p>Browser Settings: Most browsers allow you to control cookies through their settings. You can block or delete cookies by adjusting your browser settings. Please note that disabling cookies may affect the functionality of our website.</p>
      <p>Here are links to cookie management instructions for popular browsers:</p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
        <li><a href="https://support.apple.com/en-us/HT201265" target="_blank" rel="noopener noreferrer">Safari</a></li>
        <li><a href="https://support.microsoft.com/en-us/help/4468242/microsoft-edge-browsing-data-and-privacy" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
      </ul>

      <h2>5. Changes to This Cookie Policy</h2>
      <p>We may update this Cookie Policy from time to time to reflect changes in technology, legal requirements, or our services. When we do, we will revise the "Effective Date" at the top of this page. We encourage you to periodically review this page for the latest information on our cookie practices.</p>

      <h2>6. Contact Us</h2>
      <p>If you have any questions about this Cookie Policy or our data practices, please contact us at:</p>
      <p>Amalgam Inc</p>
      <p>Email: hello@amalgam-inc.com</p>
    </div>
  );
}

export default CookiePolicy;